<template>
  <DBox :id="'cmp-booking-booking_list-sidewindow-further_event_details'" :addButton="false" :addLink="false"
    :topRightMenu="[
      {
        html: hint,
        icon: 'Help2.svg',
        value: 'question',
        cardStyle: {
          width: '300px',
        },
      },
    ]">
    <template v-if="booking && booking.fields">
      <TextField2 v-for="(field, index) in booking.fields" :key="`${field.custom_data_id}`"
        :id="`${field.custom_data_id}`" :label="field.field_label" :placeholder="field.field_label" :value="field.data"
        @blur="({ name, value }) => onTextFieldBlur(field, value)"
        :bb="index == booking.fields.length - 1 ? 'none' : undefined" lw="200px"></TextField2>
    </template>
  </DBox>
</template>

<script>
import TextField from "@plugins/text-field/text-field";

export default {
  components: {
    TextField,
  },
  props: ["booking", "hint"],
  data: function () {
    return {};
  },
  computed: {},
  methods: {
    onTextFieldBlur: function (field, value) {
      this.$emit("update", {
        item: field,
        value,
      });
    },
  },
};
</script>
